<template>
    <el-row class="content">
        <el-col :span="24" style="height:calc( 100% - 5px );overflow: auto;background:#fff;">
            <div style="width:100%;height:50px;display:flex;padding:10px 20px;font-size:20px;align-items: center;box-sizing: border-box;color:#1c85f1;">{{addForm.name}}</div>
            <div id="attendFenceCon" style="position: relative;padding: 0;height: calc( 100% - 50px );width: 100%;display: flex;">
                <div class="mapContent">
                    <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%;width:100%;" @click="getClickInfo" :scroll-wheel-zoom='true'></baidu-map>
                    <div class="mapBtn">
                        <el-button type="info" @click="goBack">返回</el-button>
                        <el-button type="primary" @click="mapSaveFun">保存</el-button>
                        <!-- <button class="mapSub layui-btn layui-btn-normal" @click="mapSaveFun">保存</button> -->
                    </div>
                    <div class="mapSearch">
                        <input type="text" v-model="searchInput" id="searchCon" style="width:300px;height:40px;margin:0;" />
                        <button class="layui-btn layui-btn-normal" @click="btnSearchFun" style="height:38px;top: -2px;position: relative;margin-left:10px;">查询</button>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<script>
import myHttp from "../../untils/port.js";
import util from "../../untils/util.js"
import base from '../../untils/base'
export default {
    data(){
        return{
            projectId:'',
            center: {lng: 117.283334, lat: 31.866339},
            zoom: 13,
            map:{},
            geoc:{},
            searchInput:'',
            local:'',//本地地图查询
            addForm:{
                id:'',
                name:'',
            },
        }
    },
    mounted(){
        // this.projectId = this.$store.state.groupId;
        // this.getData();
        var params = this.$route.params;
        this.addForm.id=params.id;
    },
    methods:{
        //保存
        mapSaveFun(){
            var that = this;
            this.addForm.userId = this.$store.state.user.id;
            delete this.addForm.updateDate
            delete this.addForm.createDate
            myHttp.updateProject(this.addForm).then(function(resp){
                if(resp.data.code=="200"){
                    that.$message.success("修改成功");
                    that.$router.go(-1);
                }else{
                    that.$message.error(resp.data.msg);
                }
            });
            // if (this.currentPonit.length > 0) {
            //     var li = this.currentPonit;
            //     this.allPoint.push(li);
            // }
            // var userId = this.$store.state.userId;
            // myHttp.updateProject({
            //     id: this.projectId,
            //     userId:userId,
            //     enclosure: JSON.stringify(this.allPoint)
            // }).then(function (resp) {
            //     if (resp.code == '200') {
            //         //layer.msg("保存成功", { icon: 1 });
            //     } else {
            //         //layer.msg(resp.msg, { icon: 5 });
            //     }
            // }, function (error) {
            // });
        },
        //获取数据
        getData(){
            var that = this;
            myHttp.getProjectById({
                id: this.addForm.id
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data.project;
                    that.addForm = data;
                    if ("" != data.gpsPoint && undefined != data.gpsPoint) {
                        var obj = data.gpsPoint.split(",");
                        var point = { lng: obj[0], lat: obj[1] };
                        that.center.lng = point.lng;
                        that.center.lat = point.lat;
                        that.setCenterMap(point);
                    }
                } else {
                    that.$message.error(resp.data.msg);
                }
            }, function (error) {
            });
        },
        //地图展示
        handler ({BMap, map}) {
            this.map = map;
            this.geoc = new BMap.Geocoder();
            this.local = new BMap.LocalSearch(map, {
                renderOptions: { map: map }
            });
            this.getData();
            // var point = new BMap.Point(this.center.lng, this.center.lat)
            // map.centerAndZoom(point, 13)
            // var marker = new BMap.Marker(point) // 创建标注
            // map.addOverlay(marker) // 将标注添加到地图中
            // var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
            // map.addOverlay(circle)
        },
        //地图点击方法
        getClickInfo (e) {
            this.map.clearOverlays();
            var point = new BMap.Point(e.point.lng, e.point.lat);
            var marker = new BMap.Marker(point);
            this.map.addOverlay(marker)
            this.addForm.gpsPoint = e.point.lng+','+e.point.lat;
            // var that = this;
            // this.geoc.getLocation(e.point, function (rs) {
            //     var addComp = rs.addressComponents;
            //     var address = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
            //     that.form.address = address;
            // });
        },
        //设置地图坐标和中点
        setCenterMap(obj){
            var point = new BMap.Point(this.center.lng, this.center.lat);
            this.map.centerAndZoom(point, 12)
            var marker = new BMap.Marker(point)
            this.map.addOverlay(marker)
        },
        //点击查询
        btnSearchFun(){
            this.local.search(this.searchInput);
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
    }
}
</script>
<style scoped>
    .content{
        width: 100%;
        height: 100%;
        padding: 0;
    }
    .list li {
        border-bottom: 1px solid #ddd;
        padding: 5px;
        list-style: none;
    }
    .list li p {
        margin: 10px 0;
        display: flex;
        align-items: center;
    }
    .list li p input,.list li .el-input {
        display: inline-block;
        width: 120px;
        height: 30px;
        margin: 0;
    }
    .list li .el-input input{
        height: 30px;
    }
    .list li span {
        width: 30px;
        border-radius: 15px;
        height: 30px;
        text-align: center;
        background: #69c2fb;
        display: inline-block;
        font-size: 14px;
        line-height: 30px;
        color: #fff;
    }
    .mapBtn {
        z-index: 100;
        position: absolute;
        top: 5px;
        left: 5px;
        display: inline-block;
    }
    .mapSearch {
        z-index: 100;
        position: absolute;
        top: 5px;
        right: 5px;
        display: inline-block;
    }
    .mapClear,
    .mapSub {
        margin-right: 10px;
    }
    .delBtn {
        float: right;
        position: relative;
        right: 10px;
    }
    .list {
        width: 240px;
        height: calc(100% - 10px);
        overflow: auto;
        border-right: 1px solid #ddd;
        display: inline-block;
    }
    #allmap {
        width: 100%;
        height: 100%;
        margin: 0;
    }
    .anchorBL {
        display: none;
    }
    #allmap img {
        max-width: inherit;
    }
    .mapContent {
        width: 100%;
        height: 100%;
        position: relative;
        display: inline-block;
    }
    .list ul {
        margin: 0;
        padding: 0;
    }
    .list .ptitle {
        border-bottom: 1px solid #ddd;
        margin: 0;
        text-align: center;
        padding: 5px 0;
    }
    .selectInline {
        float: left;
        text-align: left;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
    }
</style>